export default {
  base: 'USD',
  code: 'USD'
}